import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useTabExistCheck = (validTabs, activeTab) => {
  const navigate = useNavigate();

  useEffect(() => {
    const tab = validTabs.find(x => x.value === activeTab);
    if (!tab) {
      navigate('/page-not-found');
    }
  }, [validTabs, activeTab, navigate]);
};
